export const VERIFY_LICENSE_REQUEST = "VERIFY_LICENSE_REQUEST";
export const VERIFY_LICENSE_SUCCESS = "VERIFY_LICENSE_SUCCESS";
export const VERIFY_LICENSE_ERROR = "VERIFY_LICENSE_ERROR";
